<template>
  <div
    class="selectable-card"
    :class="{ active: selected, disabled: disabled }"
    @click="handleClick"
  >
    <div class="selectable-card__icon selectable-card__icon--imagem" v-if="image">
      <img :src="image" alt="" />
    </div>
    <div class="selectable-card__icon" v-else-if="icon">
      <CIcon v-if="isCoreIcon" :name="icon" size="lg" />
      <fa-icon v-else :icon="icon" />
    </div>
    <div class="selectable-card__content">
      <div class="selectable-card__header">
        <div class="selectable-card__label">{{ label }}</div>
        <span v-if="help" class="selectable-card__help-anchor" @click.stop>
          <HintInfo :texto="help" />
        </span>
      </div>
      <div class="selectable-card__description" v-if="description">
        {{ description }}
      </div>
    </div>
    <div class="selectable-card__check" :class="{ checked: selected }">
      <CIcon v-if="selected" name="cil-check" size="sm" />
    </div>
  </div>
</template>

<script>
import HintInfo from "@/components/form/HintInfo.vue";

export default {
  name: "SelectableCard",
  components: { HintInfo },
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    help: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCoreIcon() {
      return this.icon && this.icon.startsWith("cil-");
    },
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit("select", this.value);
      }
    },
  },
};
</script>

<style scoped>
.selectable-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  user-select: none;
}

.selectable-card:hover:not(.disabled) {
  border-color: #c5c8cc;
  background-color: #fafafa;
}

.selectable-card.active {
  border-color: #3a3e81;
  background-color: #eceaf3;
}

.selectable-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.selectable-card__icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background-color: #f2f2f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #3a3e81;
}

.selectable-card__icon--imagem {
  background-color: #ffffff;
  border: 1px solid #eceef3;
}

.selectable-card__icon--imagem img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.selectable-card.active .selectable-card__icon {
  background-color: #dddce9;
}

.selectable-card__content {
  flex: 1;
  min-width: 0;
}

.selectable-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.selectable-card__label {
  font-size: 13px;
  font-weight: 600;
  color: #2c2c2c;
  line-height: 1.3;
}

.selectable-card__help-btn {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: #aaa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.selectable-card__help-anchor {
  display: inline-flex;
}

.selectable-card__help-btn:hover,
.selectable-card__help-btn.is-open {
  color: #3a3e81;
  background-color: rgba(58, 62, 129, 0.1);
}

.selectable-card__description {
  font-size: 11px;
  color: #777;
  margin-top: 2px;
  line-height: 1.3;
}

.selectable-card__check {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  align-self: center;
  transition: all 0.15s ease;
}

.selectable-card__check.checked {
  background-color: #3a3e81;
  border-color: #3a3e81;
  color: #fff;
}
</style>
